import React, { CSSProperties } from 'react';
import { FieldHeaderComponent } from '@vivli/shared/components';
import { IOrganization } from '@vivli/features/organizations/infrastructure/interface';
import { OrgMembersGridComponent } from './org-members-grid.component';
import { OrgResourcesLinkComponent } from './modals/org-resources-link.component';
import { useOrganizationDetailsContext } from '@vivli/features/organizations/infrastructure/context';
import { OrgMembersGridView } from '@vivli/shared/features/membership/views';

interface OrgMembersTabComponentProps {
    organization?: IOrganization;
}
const orgContainerStyle: CSSProperties = {
    width: '100%',
    height: '450px',
    marginBottom: '10px',
    marginTop: '10px',
};
export const OrgMembersTabComponent = ({ organization }: OrgMembersTabComponentProps) => {
    const { currentMembers, rolesOrgSpecific } = useOrganizationDetailsContext();

    return (
        <div>
            <OrgResourcesLinkComponent />

            {currentMembers && Object.keys(currentMembers).length > 0 && (
                <div style={orgContainerStyle}>
                    <OrgMembersGridView
                        currentOrgMembers={currentMembers as any}
                        organization={organization as any}
                        rolesOrgSpecific={rolesOrgSpecific}
                    />
                </div>
            )}
        </div>
    );
};
